const truncatedCell = (params) => (
  <span title={params.value} className="history-cell-truncate">
    {params.value}
  </span>
);

export const getHistoryTabColumData = (t) => [
  {
    field: "action",
    headerName: t("action") || "Action",
    sortable: false,
    filter: false,
    flex: 1.2,
    minWidth: 210,
    cellRenderer: truncatedCell,
  },
  {
    field: "oldValue",
    headerName: t("oldValue") || "Old Value",
    sortable: false,
    filter: false,
    flex: 1,
    minWidth: 180,
    cellRenderer: truncatedCell,
  },
  {
    field: "newValue",
    headerName: t("newValue") || "New Value",
    sortable: false,
    filter: false,
    flex: 1,
    minWidth: 210,
    cellRenderer: truncatedCell,
  },
  {
    field: "modifiedBy",
    headerName: t("modifiedBy") || "Modified By",
    sortable: false,
    filter: false,
    flex: 0.95,
    minWidth: 170,
    cellRenderer: truncatedCell,
  },
  {
    field: "modifiedDateTime",
    headerName: t("modifiedDateTime") || "Modified Date|Time",
    sortable: false,
    filter: false,
    flex: 1,
    minWidth: 180,
    cellRenderer: truncatedCell,
  },
  {
    field: "reason",
    headerName: t("reason") || "Reason",
    sortable: false,
    filter: false,
    flex: 1.9,
    minWidth: 280,
    cellRenderer: truncatedCell,
  },
];
